import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import format from 'date-fns/format';
import { setBadgeCount, markAllMessagesRead, setLoadingMessages, setTotalMessageCount } from '../../../../../../store/actions';
import { MESSAGE_SENDER } from '../../../../../../constants';
import './loaderStyle.css';
import Loader from './components/Loader';
import '../../../../../../../../styles.css';
import WebSocketManager from '../../../../../../../../manager/WebSocketManager';
import { useChatScrollHandler } from '../../../../../../utils/useChatScrollHandler';
import Spinner from './spinner';
import InfiniteScroll from 'react-infinite-scroll-component';
import { scrollToBottom } from '../../../../../../utils/messages';
import { getTitleTime, messageTypeArray, setMessageDateAndDisableButton } from '../../../../../../../../utils/helper';
import ConsoleUtils from '../../../../../../../../utils/console';
import { useGroupedMessages } from '../../../../../../../../hooks/useGroupedMessages';
import MessageGroup from './components/Message/messageGroup';
import moment from 'moment';

const webSocketManager = new WebSocketManager();
const Messages = ({ profileAvatar, profileClientAvatar, showTimeStamp }) => {
  const dispatch = useDispatch();
  const { messages, isSessionStarted, totalMessageCount, typing, messageType, showChat, badgeCount, messageFrom, widgetConfig, loadingMessages } = useSelector((state) => ({
    messages: state.messages.messages,
    isSessionStarted: state.messages.isSessionStarted,
    totalMessageCount: state.messages.totalMessageCount,
    badgeCount: state.messages.badgeCount,
    typing: state.behavior.messageLoader,
    messageType: state.behavior.messageType,
    showChat: state.behavior.showChat,
    messageFrom: state.behavior.messageFrom,
    widgetConfig: state.messages.widgetConfig,
    loadingMessages: state.messages.loadingMessages,
  }));
  const scrollToBottomRef = useRef(null);
  const pageNoRef = useRef(1); // Use useRef to keep track of the page number
  const pageSizeRef = useRef(20);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  // const [isAtBottom, setIsAtBottom] = useState(true);
  const [scrollButtonVisible, setScrollButtonVisible] = useState(false);
  // const [messagesArr, setMessagesArr] = useState();
  // const [currentMessage, setCurrentMessage] = useState(null)
  const messageRef = useRef(null);
  const [currentMessage, setCurrentMessage] = useState(null)
  
  const fetchMessage = async () => {
    if (loadingMessages) return;
    dispatch(setLoadingMessages(true))
    // console.log(totalMessageCount);
    // console.log(messages.length);
    // console.log(totalMessageCount > messages.length);
    
    try {      
      if(totalMessageCount > messages.length) {
        webSocketManager.send({
          id: '5397b5bf-e413-4dbc-bf9d-47bb7b5fbf53',
          payloadType: 'event',
          type: 'newPage',
          from: 'customer',
          content: {
            // pageNo: nextPage,
            pageSize: 20,
            timeStamp: messages[messages.length - 1]?.props?.message?.timeStamp || moment(messages[messages.length - 1]?.timestamp).utc().toISOString()
          }
        });
        setHasMore(true);
      } else {
        setHasMore(false);
        dispatch(setLoadingMessages(false))
      }
    } catch (error) {
        console.error("Failed to fetch messages:", error);
        setHasMore(false);
    } finally {
        // setLoading(false);
        // dispatch(setLoadingMessages(false));
    }
  };
  
  // function fetchMessage() {
  //   try {
  //     setHasMore(true);
  //     setLoading(true);
  //     const totalFetchedMessages = pageSizeRef.current + 20;

  //     if (totalFetchedMessages - 20 * pageNoRef.current >= 0) {
  //       const nextPageNo = pageNoRef.current + 1;
  //       webSocketManager.send({
  //         id: '5397b5bf-e413-4dbc-bf9d-47bb7b5fbf53',
  //         payloadType: 'event',
  //         type: 'newPage',
  //         from: 'customer',
  //         content: {
  //           pageNo: nextPageNo,
  //           pageSize: 20
  //         }
  //       });
  //       ConsoleUtils.log('total', totalFetchedMessages);
  //       ConsoleUtils.log('diff', totalFetchedMessages - messages.length);
  //       ConsoleUtils.log('messageCond', pageNoRef.current * 20);
  //       ConsoleUtils.log('messageLen', messages.length);
  //       ConsoleUtils.log('pageNo', nextPageNo);
        
  //       if ((totalFetchedMessages - messages.length > 20) || totalMessageCount === 20) {
  //         setHasMore(false);
  //       }

  //       pageNoRef.current = nextPageNo;
  //       pageSizeRef.current = totalFetchedMessages;
  //     } else {
  //       ConsoleUtils.log('You have reached your last message.');
  //       pageNoRef.current = 1;
  //       pageSizeRef.current = 20;
  //     }
  //   } catch (error) {
  //     ConsoleUtils.error('Error fetching messages:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  useEffect(async () => {
    // setMessagesArr(await setMessageDateAndDisableButton(messages))
    if (showChat && badgeCount) dispatch(markAllMessagesRead());
    else dispatch(setBadgeCount(messages.filter((message) => message.unread).length));
  }, [messages, badgeCount, showChat, dispatch]);

  const groupedMessages = useGroupedMessages(messages);

  useEffect(() => {
        if (groupedMessages) {
            setCurrentMessage(groupedMessages);
            setHasMore(true);
        } else {
            setCurrentMessage(null);
        }
    }, [groupedMessages]);

  // useEffect(() => {
  //   if (groupedMessages?.length > 0) {
  //     setHasMore(true);
  //     setLoading(false);
  //   }
  // }, [groupedMessages?.length]);

  // const getComponentToRender = (message) => {
  //   const ComponentToRender = message.component;
  //   if (message.type === 'component') {
  //     return <ComponentToRender {...message.props} />;
  //   }
  //   return <ComponentToRender message={message} showTimeStamp={showTimeStamp} />;
  // };

  const scrollToBottomHandler = () => {
    if (messageRef.current) {
      messageRef.current.scrollTop = messageRef.current.scrollHeight; // Scroll to bottom
    }
    setScrollButtonVisible(false); // Hide the button after clicking
  };

  const handleScroll = () => {
    if (messageRef.current) {
      const { scrollTop, clientHeight, scrollHeight } = messageRef.current;

      // Since scrollTop will be 0 at the bottom (due to reverse scroll), we check if it's at the top
      // ConsoleUtils.log('scrollTop:', scrollTop);
      // ConsoleUtils.log('clientHeight:', clientHeight);
      // ConsoleUtils.log('scrollHeight:', scrollHeight);

      const isUserAtTop = scrollTop >= 0 || scrollTop === 1; // We are at the "bottom" when scrollTop is 0 in reverse order
      // ConsoleUtils.log('Is user at top (bottom in UI):', isUserAtTop);

      if (!isUserAtTop) {
        setScrollButtonVisible(true); // Show the button when not at the "bottom"
      } else {
        setScrollButtonVisible(false); // Hide the button when at the "bottom"
      }
    }
  };

  useEffect(() => {
    const messageContainer = messageRef.current;
    if (messageContainer) {
      messageContainer.addEventListener('scroll', handleScroll);
    }

    // Clean up event listener on unmount
    return () => {
      if (messageContainer) {
        messageContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [messages]);

  // const isClient = (sender) => sender === MESSAGE_SENDER.CLIENT;

  useEffect(() => {
    if (scrollButtonVisible) {
      const ele = document.getElementsByClassName('rcw-sender')
      if (ele[0]) {
        scrollToBottomRef.current.style.bottom = ele[0]?.offsetHeight + 9 + 'px';
      }
    }
  }, [scrollButtonVisible])

  useEffect(() => {
    if(messages?.length === 0) {
      dispatch(setLoadingMessages(true))
      dispatch(setTotalMessageCount(0))
    } 
    // webSocketManager.addListener('open', () => setLoading(false));
    // return () => {
    //   webSocketManager.removeListener('open', () => setLoading(true));
    // };
  }, []);

  return (
    <div
      id="messages123"
      className="rcw-messages-container"
      ref={messageRef}
      style={{
        height: '100vh',
        overflowY: 'scroll',
        display: 'flex',
        flexDirection: messages?.length <= 2 ? "column" : 'column-reverse',
      }}>
      {(loadingMessages || !isSessionStarted) && <Spinner />}
      <InfiniteScroll
        dataLength={messages.length}
        next={widgetConfig?.widgetConfig?.isSessionAvailable && fetchMessage}
        scrollableTarget="messages123"
        hasMore={hasMore}
        loader={messages.length > 10 && widgetConfig?.widgetConfig?.isSessionAvailable && loadingMessages && <Spinner />}
        endMessage={''
          //   <p className="text-center m-5" style={{ color: 'black' }}>
          //     You have reached the last message
          //   </p>
        }
        style={{
          display: isSessionStarted ? 'flex' : 'none',
          flexDirection: 'column-reverse',
          overflow: 'hidden'
        }}
        inverse={true}>
        {/* {messagesArr
          ?.slice()
          .reverse()
          .map((message, index) => {
            const type =  message?.props?.message?.content?.type || message?.props?.message?.type || message?.props?.message?.data?.fileType || message?.type || '';
            return (
            <>
              {typing && index === 0 &&
                <div className='rcw-typing-container'>
                  <div className='typing-loader'>
                    <div className='loader-container'></div>
                  </div>
                  <Loader messageType={messageType} typing={typing} />
                </div>}
              {message?.text !== "/reset" && messageTypeArray.includes(type) && <div
                className={`rcw-message ${isClient(message.sender) ? 'rcw-message-client' : ''}`}
                key={`${index}-${format(message.timestamp, 'HH:mm')}`}>
                {getComponentToRender(message)}
              </div>}
              {messages.length > 0 && message?.dateLabel && <div className="rcw-title-timestamp-container"><div className="rcw-title-timestamp">{message?.dateLabel}</div></div>}
            </>
          )})} */}
            {currentMessage && currentMessage !== null && Object.entries(currentMessage)?.map(([dateLabel, messages], index) => (
              <MessageGroup
                key={`${dateLabel}-${index}`}
                dateLabel={dateLabel}
                messages={messages}
                typing={typing}
                messageType={messageType}
              />
            ))}
           {/* {groupedMessages.length > 0 && groupedMessages?.map(([dateLabel, messages]) => (
              <MessageGroup
                key={dateLabel}
                dateLabel={dateLabel}
                messages={messages}
                typing={typing}
                messageType={messageType}
              />
            ))} */}
      </InfiniteScroll>
      {scrollButtonVisible && (
        <button
          ref={scrollToBottomRef}
          className="scroll-to-bottom-btn"
          onClick={scrollToBottomHandler}
          style={{
            position: 'absolute',
            right: '20px',
            cursor: 'pointer',
            background: 'transparent',
            border: 'none',
            zIndex: 1000
          }}>
          <img src="./images/downArrow.png" className="" alt="" height={27} width={27} />
        </button>
      )}
    </div>
  );
};

export default Messages;
